import React, { PropTypes } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import NcdEntitlement from '../../quotationCVComponent/ncdEntitlement/NcdEntitlement';
import SumInsured from '../../quotationCVComponent/sumInsured/SumInsured';

const NcdEntitlementSumInsuredSection = (props) => {
  return (
    <div className="ebaoUtil__Top-Bottom-Line">
      <FormGroup controlId="EntitlementSumInsuredSection">
        <Col sm={6}>
          <NcdEntitlement
            defaultEcdEntitlement={props.particularOfMainDriver.ncdEntitlement}
            handleChangeEcdEntitlement={props.handleChangeParticularOfMainDriver}

          />
        </Col>
        <Col sm={6}>
          <SumInsured
            sumInsured={props.particularOfMainDriver.sumInsured}
            handleChangeSumInsured={props.handleChangeParticularOfMainDriver}
            validation={props.validation}
          />
        </Col>
      </FormGroup>
    </div>
  )
}

NcdEntitlementSumInsuredSection.propTypes = {
  particularOfMainDriver: PropTypes.object,
  handleChangeParticularOfMainDriver: PropTypes.func,
  validation: PropTypes.func
};

export default NcdEntitlementSumInsuredSection;



// WEBPACK FOOTER //
// ./src/app/components/quotationCVComponent/ncdEntitlementSumInsuredSection/NcdEntitlementSumInsuredSection.js